import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Widget } from 'cd-eft/utils/esriTypes';
import './EsriWidgetHost.scss';

interface IEsriWidgetHostProps {
  esriWidget: Widget | null | undefined;
  idAndName?: string;
  showAoiArea?: boolean | undefined;
  aoiArea?: string | undefined;
}

export const EsriWidgetHost = observer((props: IEsriWidgetHostProps) => {
  const divREF = useRef<any>();
  useEffect(() => {
    if (props.esriWidget) {
      if (!props.esriWidget.container) {
        props.esriWidget.container = document.createElement('div');
      }
      const container = props.esriWidget.container as any;
      container.dataset.testid = 'eft-esriwidgetcontainer';
      container.classList.add('eft-esriwidgetcontainer');

      //clear the set of children
      while (divREF.current.firstChild) {
        divREF.current.removeChild(divREF.current.firstChild);
      }
      divREF.current.appendChild(props.esriWidget.container);
    }
  });

  return (
    <div className="flex">
      {props.showAoiArea && props.aoiArea !== undefined && <div className="area-measurement">{`Area: ${props.aoiArea} acres`}</div>}
      <div className="eft-esriwidgethost" data-testid="eft-esriwidgethost" id={props.idAndName} ref={divREF}>
        <div></div>
      </div>
    </div>
  );
});

export default EsriWidgetHost;
